import { EmployerPermissions, GetAdminsQuery, GetAdminsQueryVariables } from "generated/graphql";
import { Option } from "./Option";

export type DPManager = GetAdminsQuery["managers"]["items"][0];

export const accessLevelDictionary: { [K in EmployerPermissions]: string } = {
  [EmployerPermissions.FullPermissions]: "Full",
  [EmployerPermissions.EarningsPermissions]: "Earnings",
  [EmployerPermissions.ActivationsPermissions]: "Activations",
  [EmployerPermissions.ViewOnly]: "View Only",
  [EmployerPermissions.LocalAdmin]: "Local",
  [EmployerPermissions.OperatingManager]: "Operating Manager",
};

export const permissionLabels = {
  [EmployerPermissions.FullPermissions]: "Full Permissions",
  [EmployerPermissions.ActivationsPermissions]: "Activations Permissions",
  [EmployerPermissions.EarningsPermissions]: "Earnings Permissions",
  [EmployerPermissions.ViewOnly]: "View Only",
  [EmployerPermissions.OperatingManager]: "Operating Manager",
  [EmployerPermissions.LocalAdmin]: "Local Admin",
};

export enum ManagerStatus {
  ACTIVE = "active",
  DISABLED = "disabled",
}

export type CreateAdminFormFields = {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  permissions: Option;
  companyIds: Option[];
  locations?: Option[];
};


export const initialQueryProps: GetAdminsQueryVariables = {
  page: 1,
};
